import {create} from 'zustand';
import {
  getUserTotal,
  getUserList,
} from '@/common-pages/invitation/invitation.service';
import {
  UserTotal,
  UserListItem,
} from '@/common-pages/invitation/invitation.type';
import {getRuleDetail} from '../agent.service';
import {InviteRechargeRule} from '../agent.type';

interface InvitationRewardState {
  // 数据状态
  userTotal: UserTotal | null;
  userList: UserListItem[];
  newCustomerReward: number;
  rewardRules: InviteRechargeRule[];

  // 加载状态
  loading: boolean;
  error: string | null;

  // 操作方法
  loadData: () => Promise<void>;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useInvitationRewardStore = create<InvitationRewardState>(set => ({
  // 初始状态
  userTotal: null,
  userList: [],
  newCustomerReward: 3, // mock 数据
  rewardRules: [],
  loading: false,
  error: null,

  // 加载数据
  loadData: async () => {
    set({loading: true, error: null});

    try {
      const globalStore = await import('@/services/global.state').then(
        m => m.default,
      );
      const isLoggedIn = !!globalStore.token;

      if (!isLoggedIn) {
        // 未登录时只加载奖励规则（不需要token）
        const rulesRes = await getRuleDetail();
        set({
          userTotal: null,
          userList: [],
          rewardRules: rulesRes,
          loading: false,
        });
        return;
      }

      // 已登录时并行获取所有数据
      const [totalRes, listRes, rulesRes] = await Promise.all([
        getUserTotal(),
        getUserList(),
        getRuleDetail(),
      ]);

      set({
        userTotal: totalRes,
        userList: listRes,
        rewardRules: rulesRes,
        loading: false,
      });
    } catch (error) {
      console.error('加载邀请奖励数据失败:', error);
      set({
        error: error instanceof Error ? error.message : '加载数据失败',
        loading: false,
      });
    }
  },

  // 设置加载状态
  setLoading: (loading: boolean) => {
    set({loading});
  },

  // 设置错误状态
  setError: (error: string | null) => {
    set({error});
  },
}));
